/**
 * Settings module translations - Pages section
 */

const pages = {
  title: "Settings",
  productCodes: "Product codes",
};

export default pages;
